export const fieldRegistry = {
  shortText: 'PlainUlInput',
  longText: 'PlainTextarea',
  birthDate: 'PlainDateSegmented',
  select: 'PlainSelectDynamic',
  radio: 'UlRadio',
  choice: 'PlainButtons',
  phone: 'UlPhone',
  address: 'PlainAddress',
  email: 'PlainUlInput',
  file: 'PlainAttachments',
  disclaimer: 'DisclaimerBox',
  tab: 'PlainButtonTabs',
  checkboxGroup: 'PlainCheckboxGroup',
  password: 'PlainPasswordInput'
};

export const fieldDefaults = {
  shortText: {},
  longText: { textarea: true, rows: 4 },
  birthDate: {},
  select: {},
  radio: {},
  choice: {},
  phone: { country: 'CZ' },
  address: { autocomplete: 'street-address' },
  email: { autocomplete: 'email' },
  file: { multiple: false, accept: '' },
  tab: { items: ['1', '2'] },
  checkboxGroup: {},
  password: { autocomplete: 'current-password' }
};

export const isValuePresent = value => {
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  if (value === 0) {
    return true;
  }
  if (value === false) {
    return true;
  }
  return !(value === undefined || value === null || value === '');
};
